





import Vue from 'vue'
export default Vue.extend({
    data: () => ({
        backend: process.env.VUE_APP_BACKEND
    })
})
